module.exports = __webpack_public_path__ + "img/about_contrimetric.05cf0f00.png";